import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="controller-filter"
export default class extends Controller {
  static targets = [ "dropdown", "option" ]

  // Keep dropdown open when clicking on selects
  openDropdown() {
    const dropdowns = document.querySelectorAll("div.dropdown-menu.d-block")
    
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove("d-block")
    });
    this.dropdownTarget.classList.toggle("d-block")
  }

  selectAll() {
    this.optionTargets.forEach((option) => {
      if (option) {
        option.checked = true
      }
    })
  }

  unselectAll() {
    this.optionTargets.forEach((option) => {
      if (option) {
        option.checked = false
      }
    })
  }
}